// Angular
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
// Layout
import { LayoutConfigService, ToggleOptions } from '../../../../core/_base/layout';
import { ApiService } from 'src/app/Services/api.service';
import { UtilsService } from 'src/app/Services/utils.service';
import { UserData } from 'src/app/Services/data.model';
import { OtherApiService } from 'src/app/Services/other.service';

@Component({
	selector: 'kt-header-mobile',
	templateUrl: './header-mobile.component.html',
	styleUrls: ['./header-mobile.component.scss']
})
export class HeaderMobileComponent implements OnInit {
	// Public properties
	headerLogo: string;
	asideDisplay: boolean;
	entityId = localStorage.getItem('entityId')

	toggleOptions: ToggleOptions = {
		target: 'body',
		targetState: 'kt-header__topbar--mobile-on',
		togglerState: 'kt-header-mobile__toolbar-topbar-toggler--active'
	};
	entityName: string;
	colourTheme: string;
	session: string;
	userType: string;
	sessions: any;
	sessionData: any = [];
	selected: string;
	entityGroup: any;
	selectedEntity: string;
	selectedSession: any = { };
	browserDomain: string;
	showMessage: boolean;
	entity :any= JSON.parse(localStorage.getItem('entityData'));
	/**
	 * Component constructor
	 *
	 * @param layoutConfigService: LayoutConfigService
	 */
	constructor(private layoutConfigService: LayoutConfigService, private service :OtherApiService,
		 private util : UtilsService, private ref : ChangeDetectorRef) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		this.headerLogo = localStorage.getItem('logo')|| './../../../../../assets/images/logo_1.png';
		this.asideDisplay = this.layoutConfigService.getConfig('aside.self.display');
		if(this.entity && this.entity.paymentDueMessage){
			this.showMessage = true;
		}else{
			this.showMessage = false;
		}
	}
	changeEntitySelected(event){
		this.selectedEntity = event;
		this.service.getEntityData(this.selectedEntity)
		.subscribe(res=>{
		localStorage.removeItem('sessionEndDate');
		localStorage.removeItem('sessionStartDate');
		localStorage.removeItem('session');
		localStorage.removeItem('entityType');
		localStorage.removeItem('entityId');
		localStorage.removeItem('logo')
		localStorage.removeItem('entityName')
		localStorage.removeItem('primaryColour')
		localStorage.removeItem('secondaryColour')
		localStorage.removeItem('entityPreferences')
		localStorage.removeItem('courseByTeacherData')
        localStorage.removeItem('courseByTeacherDataDateWise');

		localStorage.setItem('entityId', res._id);
         
          localStorage.setItem('logo', res.logo);
          localStorage.setItem('entityPreferences', JSON.stringify(res.entityPreferences))
          if(res.entityPreferences && res.entityPreferences.colourTheme){
            
          localStorage.setItem('secondaryColour', res.entityPreferences.colourTheme);
          localStorage.setItem('primaryColour', res.entityPreferences.colourTheme);

          if(res.entityPreferences.colourTheme == '#ffffff'){
            localStorage.setItem('primaryColour', '#1ca9c9');
          }
          }
          localStorage.setItem('entityName', res.displayName)
          localStorage.setItem('entityType', res.entityType)
          if(!res.activeSession){
            this.util.alertNotificationMessage('Please Activate A Session First');
		  window.location.href = this.browserDomain + '/academicSession';
		  return
          }else{
          localStorage.setItem('session', res.activeSession.name);
          localStorage.setItem('sessionStartDate', res.activeSession.startDate);
          localStorage.setItem('sessionEndDate', res.activeSession.endDate);
		  }
		  this.ref.detectChanges();
		//   window.location.reload();
          window.location.href = this.browserDomain + '/entityDashboard';
		
		},
		err=>{
		})
	}
	listSession(){
		this.service.getSessionList(this.entityId)
		.subscribe(data => {
			 this.sessions = data;
			 this.sessionData = data
		  },
		  err=>{
			this.util.errmsg(err);
		  });
	  }
	  compareObjects(o1: any, o2: any): boolean {
		return o1.name === o2.name;
	  }
  
	  activateSession(event){
		this.selectedSession = event;
		
		localStorage.removeItem('session');
		  localStorage.removeItem('sessionStartDate');
		  localStorage.removeItem('sessionEndDate');
		  localStorage.setItem('session', this.selectedSession.name);
		  localStorage.setItem('sessionStartDate', this.selectedSession.startDate);
		  localStorage.setItem('sessionEndDate', this.selectedSession.endDate);
		  this.util.alertMessage('Session ', 'changed to '+this.selectedSession.name)
		//   window.location.reload();
		  this.util.redirect('entityDashboard')
	  }
}
